import http from './reddit'
import qs from 'qs'
// gameLobby
export default {
  // 采种列表
  listData: (data) => {
    const query = data ? `?${qs.stringify(data, { encode: false })}` :  ''
    return http.Get(`${http.url.Newcommon}/lotplt${query}`)
  },
  // 采种详细资料
  listDataTheGame: (id) => http.Get(`${http.url.Newcommon}/lotpuge/${id}`), 
  // 修改采种
  modify: (data = {}) => http.Post(`${http.url.Newcommon}/lotpupo`, data), 
  // 新增彩種
  add: (data = {}) => http.Post(`${http.url.Newcommon}/lotpad`, data),
  // 彩票游戏列表
  gamelist: () => http.Get(`${http.url.Newcommon}/gamelist`),
  // 设定号码列表
  GamePeriodMark: (data) => http.Get(`${http.url.Newcommon}/GamePeriodMark?gamelist=${data}`),
  // 新增号码表
  addGamePeriodMark: (data) => http.Post(`${http.url.Newcommon}/addGamePeriodMark`, data),
  // 修改号码表
  updGamePeriodMark: (data) => http.Post(`${http.url.Newcommon}/updGamePeriodMark`, data),
  // 删除号码表
  delGamePeriodMark: (data) => http.Post(`${http.url.Newcommon}/delGamePeriodMark`, data),
  //下注时间调整
  gameBetTimelist: () => http.Get(`${http.url.Newcommon}/gameBetTimelist`),
  //修改下注时间调整
  gameBetTimeUpd: (data) => http.Post(`${http.url.Newcommon}/gameBetTimeUpd`, data), 
  //get rtp
  gamertplist: () => http.Get(`${http.url.Newcommon}/gamertplist`),
  //修改 rtp
  gamertpupd: (data) => http.Post(`${http.url.Newcommon}/gamertpupd`, data), 
  //清除rtp
  resetrtp: (data) => http.Post(`${http.url.Newcommon}/resetrtp`, data), 
  //RTP计算方式列表
  RTPSetList: () => http.Get(`${http.url.Newcommon}/RTPSetList`),
  //rtp计算方式
  RTPSetUpd: (data) => http.Post(`${http.url.Newcommon}/RTPSetUpd`, data),
  // 已设定号码列表
  GamePeriodMarkAll: (query) => http.Get(`${http.url.Newcommon}/GamePeriodMarkAll?${qs.stringify(query, { encode: false })}`),
  // 号码表变动纪录表
  GamePeriodMarklog: (query) => http.Get(`${http.url.Newcommon}/GamePeriodMarklog?${qs.stringify(query, { encode: false })}`),
  // 取的日开彩结算时间
  GetLotteryDailyTime: () => http.Get(`${http.url.Newcommon}/getponeLot`),
  // 自訂日開彩結算時間
  SettingLotteryDailyTime: (data) => http.Post(`${http.url.Newcommon}/postponeLot`, data),
  // 輸入號碼估算輸贏
  SetEstimatedNumber: (data) => http.Post(`${http.url.Newcommon}/getEstimated`, data),
  // 輸入游戏编号, RTP 產生 號碼
  SetEstimatedRTP: (data) => http.Post(`${http.url.Newcommon}/getRtpMark`, data),
  // 輸入游戏编号产生该局下注金额
  GetGameToval: (data) => http.Post(`${http.url.Newcommon}/getToval`, data),
  // 一鍵開關ＲＴＰ
  gameRTPAllSet: (data) => http.Post(`${http.url.Newcommon}/gamertpopen`, data),
  // RTP定時任務列表
  gameRTPtimesetList: () => http.Get(`${http.url.Newcommon}/gamertptimeopenList`),
  // RTP定時任務設定
  gameRTPtimeset: (data) => http.Post(`${http.url.Newcommon}/gamertptimeopen`, data),
}